import styled from 'styled-components/macro';
import info from '../../assets/icons/information-circle.svg';

export const Wrapper = styled.div`
  width: fit-content;
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const Text = styled.span<{ isFulfilled: boolean; isError: boolean }>`
  cursor: pointer;
  color: ${(props) =>
    props.isFulfilled ? '#2d67d8' : props.isError ? '#E53E3E' : '#697180'};
`;

export const Icon = styled.img`
  width: 24px;
  height: 24px;
  margin-right: 8px;
`;

export const InfoIcon = styled.img.attrs({
  src: info,
})`
  width: 16px;
  height: 16px;
  margin-left: 8px;
`;
